<template>
  <span class="sp_wrapper" :class="mybg">
    <a href="#" @click.prevent="toggle">{{ w }}</a>
    <div class="comp" :class="box">
      <input type="text" />
    </div>
  </span>
</template>

<script>
export default {
  props: ["w"],
  data() {
    return {
      box: "invi",
      tog: false,
      mybg: "bg0",
    };
  },
  watch: {
    tog() {
      if (this.tog) {
        this.box = "visi";
        this.mybg = "bg1";
      } else {
        this.box = "invi";
        this.mybg = "bg0";
      }
    },
  },
  methods: {
    toggle() {
      this.tog = !this.tog;
    },
  },
};
</script>


<style lang="scss" scoped>
.sp_wrapper {
  position: relative;
}
.invi {
  visibility: hidden;
}

.visi {
  visibility: visible;
}

.comp {
  position: absolute;
  top: 1.2rem;
  left: -2.5rem;
}
.bg1 {
  background: cyan;
}
.bg0 {
  //   background: white;
}
</style>